// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/Tokens.jsx.
 * Loaded AFTER index.css (and after the page's own inline \\3c style>) so
 * equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * Strategy:
 *   - Tablet (<=991px): search bar wraps, inline selects stay but shrink.
 *     Token rows already reflow to card layout via inline \\3c style> at this breakpoint.
 *   - Mobile (<=576px): full single-column layout, search bar stacks,
 *     inline selects hidden (filter modal covers them), modals become bottom
 *     sheets, all touch targets >=44px.
 *
 * DO NOT EDIT src/index.css. All overrides live here.
 */

/* ===========================================================================
 * TABLET (<=991px): toolbar wraps, minor layout tweaks
 * ======================================================================== */
@media (max-width: 991px) {
  /* Allow filter bar to wrap so controls don't overflow */
  .tokens-page .search-filter-bar {
    flex-wrap: wrap;
  }

  /* Search box expands to fill the row */
  .tokens-page .search-box {
    flex: 1 1 100%;
    min-width: 0;
  }

  /* Inline selects shrink and share the second row */
  .tokens-page .inline-select {
    flex: 1 1 auto;
    max-width: none;
    min-height: 44px;
  }

  /* Filter and refresh buttons stay tappable */
  .tokens-page .btn-filter,
  .tokens-page .btn-icon-only {
    min-height: 44px;
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full single-column, app-like layout
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Page wrapper: no horizontal overflow ---- */
  .tokens-page {
    overflow-x: hidden;
  }

  /* ---- Page header: full-width add button ---- */
  .tokens-page .rd-page-header > .rd-btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ---- Premium upsell banner: stack ---- */
  .tokens-page .nt-upsell {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .tokens-page .nt-upsell-btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ---- Search / filter bar: single-column stack ---- */
  .tokens-page .search-filter-bar {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 1rem;
  }

  .tokens-page .search-box {
    width: 100%;
    flex: none;
    min-height: 44px;
    padding: 0.5rem 0.875rem;
    max-width: 100%;
  }

  /* Hide inline selects on mobile — the Filter modal covers those options */
  .tokens-page .inline-select {
    display: none;
  }

  /* Filter and refresh buttons sit side-by-side on their own row */
  .tokens-page .btn-filter {
    flex: 1 1;
    justify-content: center;
    min-height: 44px;
  }

  .tokens-page .btn-icon-only {
    min-height: 44px;
    min-width: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* ---- Token table / card view ---- */
  .tokens-page .tokens-table-wrap {
    border-radius: 8px;
  }

  /* Token row: already a 2-column grid at <=991px via inline style.
     On narrow mobile further reduce padding and keep layout clean. */
  .tokens-page .token-row {
    padding: 0.875rem 0.75rem;
    gap: 0.5rem;
  }

  /* Symbol + name: prevent long names from pushing layout */
  .tokens-page .t-name {
    max-width: 160px;
  }

  /* Contract address: truncate more aggressively on mobile */
  .tokens-page .contract-cell code {
    font-size: 0.72rem;
  }

  /* Action buttons: already 44x44 at <=991px; confirm here */
  .tokens-page .row-action {
    width: 44px;
    height: 44px;
  }

  /* Merchant toggle switch: pad the hit area to >=44px on touch */
  .tokens-page .td-actions .rd-switch {
    /* padding: 11px 2px; */
    box-sizing: content-box;
  }

  .tokens-page .icon-mini {
    width: 36px;
    height: 36px;
  }

  /* ---- Empty / loading states ---- */
  .tokens-page .empty-state,
  .tokens-page .loading-state {
    padding: 2.5rem 1rem;
  }

  .tokens-page .empty-state .btn-primary,
  .tokens-page .empty-state .btn-secondary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ---- Pagination footer ---- */
  .tokens-page .pagination-bar {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    margin-top: 0.75rem;
  }

  .tokens-page .pagination-controls {
    gap: 0.25rem;
  }

  .tokens-page .page-btn {
    width: 44px;
    height: 44px;
  }

  .tokens-page .page-indicator {
    font-size: 0.8rem;
  }

  /* ---- Modals → bottom sheets ----
     The Tokens.jsx modals use .modal-overlay + .modal-container (defined in
     an inline \\3c style> tag). That inline tag is runtime-injected into <head>
     after the compiled CSS bundle, so it wins at equal specificity.
     We use !important only for the layout properties that must flip on mobile
     to achieve the bottom-sheet effect; cosmetic properties are left alone. */

  /* Pin overlay to the bottom edge (overrides inline style's center alignment) */
  .modal-overlay {
    align-items: flex-end !important;
    justify-content: stretch !important;
    padding: 0 !important;
  }

  /* Full-width bottom sheet */
  .modal-container {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 90vh;
    border-radius: 16px 16px 0 0 !important;
    animation: tokens-sheet-up 0.25s ease;
    padding-bottom: env(safe-area-inset-bottom);
    margin: 0;
  }

  /* Slide-up animation */
  @keyframes tokens-sheet-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0);    }
  }

  /* Footer buttons inside sheet: full-width stack on small screens */
  .modal-container .modal-footer {
    flex-direction: column-reverse;
    gap: 0.625rem;
    padding: 1rem;
  }

  .modal-container .modal-footer .btn-primary,
  .modal-container .modal-footer .btn-secondary,
  .modal-container .modal-footer .btn-danger {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* Form rows inside modal collapse to single column */
  .modal-container .form-row {
    grid-template-columns: 1fr;
  }

  /* Modal close button: adequate tap target */
  .modal-container .modal-close {
    min-width: 44px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* Ensure form inputs inside modal are full-width and tappable */
  .modal-container .form-group input,
  .modal-container .form-group select {
    min-height: 44px;
    font-size: 1rem; /* prevent iOS auto-zoom (>=16px threshold) */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Tokens.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;;6EAE6E;AAC7E;EACE,wDAAwD;EACxD;IACE,eAAe;EACjB;;EAEA,uCAAuC;EACvC;IACE,cAAc;IACd,YAAY;EACd;;EAEA,mDAAmD;EACnD;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA,6CAA6C;EAC7C;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,mDAAmD;EACnD;IACE,kBAAkB;EACpB;;EAEA,iDAAiD;EACjD;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,uDAAuD;EACvD;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;EACjB;;EAEA,0EAA0E;EAC1E;IACE,aAAa;EACf;;EAEA,iEAAiE;EACjE;IACE,SAAO;IACP,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;EACpB;;EAEA;qEACmE;EACnE;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA,0DAA0D;EAC1D;IACE,gBAAgB;EAClB;;EAEA,2DAA2D;EAC3D;IACE,kBAAkB;EACpB;;EAEA,2DAA2D;EAC3D;IACE,WAAW;IACX,YAAY;EACd;;EAEA,gEAAgE;EAChE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qCAAqC;EACrC;;IAEE,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;;8EAK4E;;EAE5E,+EAA+E;EAC/E;IACE,gCAAgC;IAChC,mCAAmC;IACnC,qBAAqB;EACvB;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,uCAAuC;IACvC,qCAAqC;IACrC,2CAA2C;IAC3C,SAAS;EACX;;EAEA,uBAAuB;EACvB;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,KAAK;EACtC;;EAEA,mEAAmE;EACnE;IACE,8BAA8B;IAC9B,aAAa;IACb,aAAa;EACf;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,qDAAqD;EACrD;IACE,0BAA0B;EAC5B;;EAEA,4CAA4C;EAC5C;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,gEAAgE;EAChE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,6CAA6C;EAChE;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/Tokens.jsx.\n * Loaded AFTER index.css (and after the page's own inline <style>) so\n * equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * Strategy:\n *   - Tablet (<=991px): search bar wraps, inline selects stay but shrink.\n *     Token rows already reflow to card layout via inline <style> at this breakpoint.\n *   - Mobile (<=576px): full single-column layout, search bar stacks,\n *     inline selects hidden (filter modal covers them), modals become bottom\n *     sheets, all touch targets >=44px.\n *\n * DO NOT EDIT src/index.css. All overrides live here.\n */\n\n/* ===========================================================================\n * TABLET (<=991px): toolbar wraps, minor layout tweaks\n * ======================================================================== */\n@media (max-width: 991px) {\n  /* Allow filter bar to wrap so controls don't overflow */\n  .tokens-page .search-filter-bar {\n    flex-wrap: wrap;\n  }\n\n  /* Search box expands to fill the row */\n  .tokens-page .search-box {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  /* Inline selects shrink and share the second row */\n  .tokens-page .inline-select {\n    flex: 1 1 auto;\n    max-width: none;\n    min-height: 44px;\n  }\n\n  /* Filter and refresh buttons stay tappable */\n  .tokens-page .btn-filter,\n  .tokens-page .btn-icon-only {\n    min-height: 44px;\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full single-column, app-like layout\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Page wrapper: no horizontal overflow ---- */\n  .tokens-page {\n    overflow-x: hidden;\n  }\n\n  /* ---- Page header: full-width add button ---- */\n  .tokens-page .rd-page-header > .rd-btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ---- Premium upsell banner: stack ---- */\n  .tokens-page .nt-upsell {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .tokens-page .nt-upsell-btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ---- Search / filter bar: single-column stack ---- */\n  .tokens-page .search-filter-bar {\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 1rem;\n  }\n\n  .tokens-page .search-box {\n    width: 100%;\n    flex: none;\n    min-height: 44px;\n    padding: 0.5rem 0.875rem;\n    max-width: 100%;\n  }\n\n  /* Hide inline selects on mobile — the Filter modal covers those options */\n  .tokens-page .inline-select {\n    display: none;\n  }\n\n  /* Filter and refresh buttons sit side-by-side on their own row */\n  .tokens-page .btn-filter {\n    flex: 1;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  .tokens-page .btn-icon-only {\n    min-height: 44px;\n    min-width: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* ---- Token table / card view ---- */\n  .tokens-page .tokens-table-wrap {\n    border-radius: 8px;\n  }\n\n  /* Token row: already a 2-column grid at <=991px via inline style.\n     On narrow mobile further reduce padding and keep layout clean. */\n  .tokens-page .token-row {\n    padding: 0.875rem 0.75rem;\n    gap: 0.5rem;\n  }\n\n  /* Symbol + name: prevent long names from pushing layout */\n  .tokens-page .t-name {\n    max-width: 160px;\n  }\n\n  /* Contract address: truncate more aggressively on mobile */\n  .tokens-page .contract-cell code {\n    font-size: 0.72rem;\n  }\n\n  /* Action buttons: already 44x44 at <=991px; confirm here */\n  .tokens-page .row-action {\n    width: 44px;\n    height: 44px;\n  }\n\n  /* Merchant toggle switch: pad the hit area to >=44px on touch */\n  .tokens-page .td-actions .rd-switch {\n    /* padding: 11px 2px; */\n    box-sizing: content-box;\n  }\n\n  .tokens-page .icon-mini {\n    width: 36px;\n    height: 36px;\n  }\n\n  /* ---- Empty / loading states ---- */\n  .tokens-page .empty-state,\n  .tokens-page .loading-state {\n    padding: 2.5rem 1rem;\n  }\n\n  .tokens-page .empty-state .btn-primary,\n  .tokens-page .empty-state .btn-secondary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ---- Pagination footer ---- */\n  .tokens-page .pagination-bar {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n    margin-top: 0.75rem;\n  }\n\n  .tokens-page .pagination-controls {\n    gap: 0.25rem;\n  }\n\n  .tokens-page .page-btn {\n    width: 44px;\n    height: 44px;\n  }\n\n  .tokens-page .page-indicator {\n    font-size: 0.8rem;\n  }\n\n  /* ---- Modals → bottom sheets ----\n     The Tokens.jsx modals use .modal-overlay + .modal-container (defined in\n     an inline <style> tag). That inline tag is runtime-injected into <head>\n     after the compiled CSS bundle, so it wins at equal specificity.\n     We use !important only for the layout properties that must flip on mobile\n     to achieve the bottom-sheet effect; cosmetic properties are left alone. */\n\n  /* Pin overlay to the bottom edge (overrides inline style's center alignment) */\n  .modal-overlay {\n    align-items: flex-end !important;\n    justify-content: stretch !important;\n    padding: 0 !important;\n  }\n\n  /* Full-width bottom sheet */\n  .modal-container {\n    width: 100% !important;\n    max-width: 100% !important;\n    max-height: 90vh;\n    border-radius: 16px 16px 0 0 !important;\n    animation: tokens-sheet-up 0.25s ease;\n    padding-bottom: env(safe-area-inset-bottom);\n    margin: 0;\n  }\n\n  /* Slide-up animation */\n  @keyframes tokens-sheet-up {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0);    }\n  }\n\n  /* Footer buttons inside sheet: full-width stack on small screens */\n  .modal-container .modal-footer {\n    flex-direction: column-reverse;\n    gap: 0.625rem;\n    padding: 1rem;\n  }\n\n  .modal-container .modal-footer .btn-primary,\n  .modal-container .modal-footer .btn-secondary,\n  .modal-container .modal-footer .btn-danger {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* Form rows inside modal collapse to single column */\n  .modal-container .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  /* Modal close button: adequate tap target */\n  .modal-container .modal-close {\n    min-width: 44px;\n    min-height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Ensure form inputs inside modal are full-width and tappable */\n  .modal-container .form-group input,\n  .modal-container .form-group select {\n    min-height: 44px;\n    font-size: 1rem; /* prevent iOS auto-zoom (>=16px threshold) */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
